"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var localizers = require("./util/localizers");
function setLocalizers(_a) {
    var date = _a.date, number = _a.number, message = _a.message;
    date && exports.setDateLocalizer(date);
    number && exports.setNumberLocalizer(number);
    message && exports.setMessageLocalizer(message);
}
exports.setLocalizers = setLocalizers;
exports.setDateLocalizer = localizers.setDate;
exports.setNumberLocalizer = localizers.setNumber;
exports.setMessageLocalizer = localizers.setMessage;



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/configure.js
// module id = 66
// module chunks = 0 1 2 3 4 5 6